import ObjectField from "./object-field";
import ObjectSelectField from './object-select-field';
import TitleField from "./title-field";

export default {
  ObjectField,
  ObjectSelectField,
  TitleField
};



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/fields/index.js